import React from 'react'
import { copyToClipboard } from './Utils'
import { usePopper } from 'react-popper'
import ClickToCopy from './ClickToCopy'

const GenesisSongShareButton = ({ song_id, size, className }) => {
  const song_url = 'https://arpeggi.io/listen?song=' + String(song_id)

  return (
    <ClickToCopy copyContent={song_url} className={className}>
      <img
        src="/static/icons/share_black.svg"
        style={{
          height: size,
          width: size
        }}
      />
    </ClickToCopy>
  )
}

export default GenesisSongShareButton
